import React from 'react'

function TermsScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '4rem',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{ maxWidth: '1200px', padding: '0 2rem', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 className="pub-h2" style={{ marginBottom: '0.5rem' }}>Regulamin serwisu SIGMA</h1>
          <p className="pub-small">Obowiązuje od 2025 roku</p>
        </div>

        <div style={{
          background: '#fff', border: '1px solid var(--pub-line)',
          borderRadius: '8px',
          padding: 'clamp(1.25rem, 4vw, 3rem)',
          boxShadow: 'none'
        }}>

          <h4 style={{ fontWeight: 'bold', marginBottom: '1rem' }}>1. Postanowienia ogólne</h4>
          <p>
            Niniejszy Regulamin określa zasady korzystania z serwisu SIGMA dostępnego pod adresem 
            <strong> sigmawork.pl</strong>. Operatorem Serwisu jest 
            <strong> Monika Józefowska</strong>, prowadząca działalność gospodarczą pod firmą 
            <strong> MONIKA JÓZEFOWSKA</strong>.
          </p>
          <p><strong>Dane rejestrowe Sprzedawcy:</strong></p>
          <ul>
            <li><strong>Nazwa firmy:</strong> MONIKA JÓZEFOWSKA</li>
            <li><strong>NIP:</strong> 9970059671</li>
            <li><strong>REGON:</strong> 527997318</li>
            <li><strong>Forma prawna:</strong> osoba fizyczna prowadząca działalność gospodarczą</li>
            <li><strong>Adres:</strong> ul. Pogodna 15, 98-400 Wieruszów, woj. łódzkie</li>
            <li><strong>E-mail:</strong> sigmaworkmj@gmail.com</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>2. Definicje</h4>
          <ul>
            <li><strong>Serwis</strong> – platforma internetowa dostępna pod adresem sigmawork.pl</li>
            <li><strong>Sprzedawca</strong> – Monika Józefowska prowadząca działalność gospodarczą</li>
            <li><strong>Klient/Użytkownik</strong> – osoba fizyczna, prawna lub jednostka organizacyjna korzystająca z Serwisu</li>
            <li><strong>Konsument</strong> – osoba fizyczna dokonująca czynności prawnej niezwiązanej bezpośrednio z jej działalnością gospodarczą lub zawodową</li>
            <li><strong>Produkt</strong> – dostępna w Serwisie rzecz ruchoma będąca przedmiotem Umowy Sprzedaży</li>
            <li><strong>Usługa</strong> – świadczenie oferowane przez Sprzedawcę za pośrednictwem Serwisu</li>
            <li><strong>Umowa Sprzedaży</strong> – umowa sprzedaży Produktu lub świadczenia Usługi zawierana między Klientem a Sprzedawcą za pośrednictwem Serwisu</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>3. Oferta i zawarcie umowy</h4>
          <p>
            Serwis SIGMA oferuje następujące produkty i usługi:
          </p>
          <ul>
            <li>Produkty – wraz z opisem, ceną w PLN oraz zdjęciami poglądowymi</li>
            <li>Usługi – wraz z opisem i ceną w PLN</li>
          </ul>
          <p>
            Wszystkie ceny podane w Serwisie są cenami brutto (zawierają podatek VAT).
          </p>
          <p>
            <strong>Procedura składania zamówienia:</strong>
          </p>
          <ol>
            <li>Wybór produktu lub usługi i dodanie do koszyka</li>
            <li>Uzupełnienie danych kontaktowych i adresu dostawy (jeśli dotyczy)</li>
            <li>Wybór metody płatności</li>
            <li>Potwierdzenie zamówienia poprzez kliknięcie przycisku <strong>„Zamawiam i płacę"</strong></li>
            <li>Po złożeniu zamówienia Klient otrzymuje potwierdzenie na podany adres e-mail</li>
          </ol>
          <p>
            Umowa sprzedaży zostaje zawarta z chwilą potwierdzenia przyjęcia zamówienia przez Sprzedawcę.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>4. Metody płatności</h4>
          <p>Klient może dokonać płatności za zamówienie poprzez:</p>
          <ul>
            <li>Szybkie przelewy elektroniczne (PayU)</li>
            <li>Płatność kartą płatniczą (PayU)</li>
            <li>Przelew tradycyjny na rachunek bankowy Sprzedawcy</li>
          </ul>
          <p>
            W przypadku wyboru przelewu tradycyjnego, termin realizacji zamówienia liczy się od daty wpływu środków na konto Sprzedawcy.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>5. Czas i sposób realizacji zamówienia</h4>
          <p>
            <strong>Czas realizacji zamówienia:</strong>
          </p>
          <ul>
            <li>Produkty fizyczne – do <strong>14 dni roboczych</strong> od potwierdzenia zamówienia i zaksięgowania płatności</li>
            <li>Usługi – termin realizacji określony jest indywidualnie w opisie każdej usługi, zwykle do <strong>30 dni roboczych</strong> od potwierdzenia zamówienia</li>
            <li>Produkty cyfrowe – dostępne natychmiast po zaksięgowaniu płatności</li>
          </ul>
          <p>
            <strong>Sposób dostawy:</strong>
          </p>
          <ul>
            <li>Produkty fizyczne są wysyłane za pośrednictwem firm kurierskich lub Poczty Polskiej na adres wskazany przez Klienta</li>
            <li>Usługi są świadczone online lub w miejscu uzgodnionym z Klientem</li>
            <li>Produkty cyfrowe są dostarczane drogą elektroniczną na adres e-mail Klienta</li>
          </ul>
          <p>
            W przypadku opóźnień w realizacji zamówienia, Sprzedawca zobowiązuje się poinformować Klienta o nowym terminie realizacji.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>6. Prawo odstąpienia od umowy (dla Konsumentów)</h4>
          <p>
            Konsument ma prawo odstąpić od umowy zawartej na odległość bez podania przyczyny w terminie <strong>14 dni kalendarzowych</strong>.
          </p>
          <p>
            <strong>Termin do odstąpienia od umowy wygasa po upływie 14 dni od dnia:</strong>
          </p>
          <ul>
            <li>w którym Konsument wszedł w posiadanie produktu lub w którym osoba trzecia inna niż przewoźnik i wskazana przez Konsumenta weszła w posiadanie produktu,</li>
            <li>zawarcia umowy – w przypadku usług.</li>
          </ul>
          <p>
            <strong>Aby skorzystać z prawa odstąpienia, Konsument musi poinformować Sprzedawcę o swojej decyzji:</strong>
          </p>
          <ul>
            <li>Drogą mailową na adres: <strong>sigmaworkmj@gmail.com</strong></li>
            <li>Listownie na adres: <strong>ul. Pogodna 15, 98-400 Wieruszów</strong></li>
          </ul>
          <p>
            Oświadczenie może być złożone na formularzu, którego wzór stanowi załącznik do niniejszego Regulaminu (dostępny na żądanie), jednak nie jest to obowiązkowe.
          </p>
          <p>
            <strong>Zwrot płatności:</strong>
          </p>
          <p>
            Sprzedawca dokona zwrotu wszystkich otrzymanych płatności, w tym kosztów dostawy (z wyjątkiem dodatkowych kosztów wynikających z wybranego przez Konsumenta sposobu dostawy innego niż najtańszy zwykły sposób dostawy oferowany przez Sprzedawcę), niezwłocznie, a w każdym przypadku nie później niż 14 dni od dnia, w którym Sprzedawca został poinformowany o decyzji Konsumenta o wykonaniu prawa odstąpienia od umowy.
          </p>
          <p>
            Zwrot płatności zostanie dokonany przy użyciu takich samych sposobów płatności, jakie zostały użyte w pierwotnej transakcji, chyba że Konsument wyraźnie zgodził się na inne rozwiązanie.
          </p>
          <p>
            <strong>Wyjątki od prawa odstąpienia:</strong>
          </p>
          <p>Prawo odstąpienia od umowy nie przysługuje Konsumentowi w przypadku:</p>
          <ul>
            <li>świadczenia usług, jeżeli Sprzedawca wykonał w pełni usługę za wyraźną zgodą Konsumenta,</li>
            <li>dostaw treści cyfrowych, które nie są zapisane na nośniku materialnym, jeżeli spełnianie świadczenia rozpoczęło się za wyraźną zgodą Konsumenta przed upływem terminu do odstąpienia od umowy i po poinformowaniu go przez Sprzedawcę o utracie prawa odstąpienia od umowy,</li>
            <li>dostaw produktów zapakowanych, które po dostarczeniu zostały rozpakowane i ze względów higienicznych lub ochrony zdrowia nie nadają się do zwrotu.</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>7. Procedura zwrotu towaru</h4>
          <p>
            <strong>Adres do zwrotów:</strong><br />
            Monika Józefowska<br />
            ul. Pogodna 15<br />
            98-400 Wieruszów<br />
            woj. łódzkie
          </p>
          <p>
            Konsument ponosi bezpośrednie koszty zwrotu rzeczy. Sprzedawca może wstrzymać się ze zwrotem płatności do czasu otrzymania produktu z powrotem lub do czasu dostarczenia dowodu jego odesłania, w zależności od tego, które zdarzenie nastąpi wcześniej.
          </p>
          <p>
            <strong>Stan zwracanego towaru:</strong>
          </p>
          <p>
            Konsument odpowiada za zmniejszenie wartości produktu wynikające z korzystania z niego w sposób inny niż było to konieczne do stwierdzenia charakteru, cech i funkcjonowania produktu.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>8. Reklamacje dotyczące produktów i usług</h4>
          <p>
            Sprzedawca ma obowiązek dostarczyć produkt wolny od wad. Podstawa i zakres odpowiedzialności Sprzedawcy z tytułu rękojmi są określone w ustawie z dnia 23 kwietnia 1964 r. – Kodeks cywilny (dla umów zawartych do 31 grudnia 2022 r.) oraz w ustawie z dnia 30 maja 2014 r. o prawach konsumenta (dla umów zawartych od 1 stycznia 2023 r.).
          </p>
          <p>
            <strong>Zgłoszenie reklamacji:</strong>
          </p>
          <ul>
            <li><strong>E-mail:</strong> sigmaworkmj@gmail.com</li>
            <li><strong>Telefon:</strong> dostępny na żądanie</li>
            <li><strong>Adres korespondencyjny:</strong> ul. Pogodna 15, 98-400 Wieruszów</li>
          </ul>
          <p>
            Reklamacja powinna zawierać:
          </p>
          <ul>
            <li>Dane kontaktowe Klienta</li>
            <li>Opis wady lub problemu</li>
            <li>Żądanie Klienta (naprawa, wymiana, obniżenie ceny, odstąpienie od umowy)</li>
            <li>Dowód zakupu (np. paragon, faktura)</li>
          </ul>
          <p>
            <strong>Termin rozpatrzenia reklamacji:</strong> Sprzedawca ustosunkuje się do reklamacji w terminie <strong>14 dni</strong> od dnia jej otrzymania. Brak odpowiedzi w tym terminie oznacza uznanie reklamacji za uzasadnioną.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>9. Rejestracja i logowanie</h4>
          <p>
            Aby korzystać z pełnej funkcjonalności Serwisu, konieczne może być założenie konta użytkownika. Przy rejestracji Użytkownik zobowiązany jest do podania prawdziwych danych oraz ochrony hasła przed dostępem osób trzecich.
          </p>
          <p>
            Użytkownik ma prawo w każdej chwili usunąć swoje konto, kontaktując się ze Sprzedawcą.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>10. Zasady korzystania z Serwisu</h4>
          <ul>
            <li>Użytkownik zobowiązuje się do korzystania z Serwisu zgodnie z obowiązującym prawem i dobrymi obyczajami.</li>
            <li>Zabronione jest dostarczanie treści o charakterze bezprawnym.</li>
            <li>Zabronione jest podejmowanie działań zakłócających funkcjonowanie Serwisu.</li>
            <li>Sprzedawca ma prawo zablokować lub usunąć konto w przypadku naruszenia Regulaminu.</li>
          </ul>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>11. Dane osobowe</h4>
          <p>
            Dane osobowe Użytkowników przetwarzane są zgodnie z Polityką Prywatności dostępną w Serwisie, która stanowi integralną część niniejszego Regulaminu.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>12. Odpowiedzialność</h4>
          <p>
            Sprzedawca dokłada wszelkich starań, aby Serwis działał w sposób ciągły i bezawaryjny, jednak nie ponosi odpowiedzialności za przerwy wynikające z przyczyn technicznych, awarii sprzętu, działań osób trzecich lub przyczyn niezależnych od Sprzedawcy.
          </p>
          <p>
            Sprzedawca nie ponosi odpowiedzialności za szkody wynikające z nieprawidłowego korzystania z Serwisu przez Użytkownika.
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>13. Pozasądowe sposoby rozpatrywania reklamacji i dochodzenia roszczeń</h4>
          <p>
            Konsument ma możliwość skorzystania z pozasądowych sposobów rozpatrywania reklamacji i dochodzenia roszczeń. Informacje o tych możliwościach dostępne są na stronie internetowej Urzędu Ochrony Konkurencji i Konsumentów: <a href="https://www.uokik.gov.pl" target="_blank" rel="noopener noreferrer">www.uokik.gov.pl</a>
          </p>
          <p>
            Konsument może skorzystać z platformy ODR dostępnej pod adresem: <a href="http://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">http://ec.europa.eu/consumers/odr</a>
          </p>

          <h4 style={{ fontWeight: 'bold', marginTop: '2rem', marginBottom: '1rem' }}>14. Postanowienia końcowe</h4>
          <p>
            Sprzedawca zastrzega sobie prawo do zmiany Regulaminu. O zmianach Użytkownicy będą informowani poprzez publikację nowej wersji Regulaminu w Serwisie z co najmniej 7-dniowym wyprzedzeniem. Korzystanie z Serwisu po wprowadzeniu zmian oznacza ich akceptację.
          </p>
          <p>
            W sprawach nieuregulowanych w niniejszym Regulaminie mają zastosowanie przepisy prawa polskiego, w szczególności:
          </p>
          <ul>
            <li>Kodeksu cywilnego</li>
            <li>Ustawy o prawach konsumenta</li>
            <li>Ustawy o świadczeniu usług drogą elektroniczną</li>
          </ul>
          <p>
            Ewentualne spory wynikłe na tle stosowania niniejszego Regulaminu będą rozstrzygane przez właściwe polskie sądy powszechne.
          </p>

          <p style={{ marginTop: '2rem', color: '#666', fontSize: '0.9rem' }}><small>Data ostatniej aktualizacji: 2025 rok</small></p>

        </div>
      </div>
    </div>
  )
}

export default TermsScreen